import { Vector2 } from '@adaptiva/core/space';
import { InputSignal, ModelSignal } from '@angular/core';

export interface IViewbox {

	x: ModelSignal<float>;

	y: ModelSignal<float>;

	z: ModelSignal<float>;

	canPan: ModelSignal<boolean>;

	minZoom: InputSignal<float>;

	zoomFactor: InputSignal<float>;

	getCenter(): Vector2;

	repaint(x: float, y: float, z: float): void;

	applyTransition(): void;

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export abstract class IViewbox { }
